export default __webpack_public_path__ + "static/media/eye_darkGreen.d221cf3a.svg";